<span [ngClass]="{ active: isActive }">
  <a
    class="menuitems"
    [ngClass]="{ hastext: hasDisplayText }"
    routerLinkActive="selectedmenu"
    [routerLinkActiveOptions]="{ exact: true }"
    [routerLink]="link"
  >
    <ion-icon
      class="sidebar-icon"
      [ngClass]="{ active: isActive }"
      [src]="icon"
    ></ion-icon>
    @if (hasDisplayText) {
      <span [ngClass]="{ active: isActive }" class="main-label">
        {{ displayText }}
      </span>
    }
  </a>
</span>
